const middleware = {}

middleware['login-from-epaper'] = require('../themes/neue/middleware/login-from-epaper.js')
middleware['login-from-epaper'] = middleware['login-from-epaper'].default || middleware['login-from-epaper']

middleware['tracking-helper'] = require('../themes/neue/middleware/tracking-helper.js')
middleware['tracking-helper'] = middleware['tracking-helper'].default || middleware['tracking-helper']

export default middleware
